import styled, { css } from 'styled-components';
import Button from 'products/nomad_insurance/components/Button';
import { sizes } from 'style';

export const StyledButton = styled(Button)`
  flex: 1;
  white-space: nowrap;
  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.5;
    `};
`;

export const ButtonRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 16px;
  width: 100%;

  @media ${sizes.desktop} {
    width: auto;
  }
`;
